import axios from "axios";
import {
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST,
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS,
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL,
  PAYMENT_TENANT_GET_MODULES_REQUEST,
  PAYMENT_TENANT_GET_MODULES_SUCCESS,
  PAYMENT_TENANT_GET_MODULES_FAIL,
} from "../constants/paymentConstants";
import { listTenantDetailsBySlugAction } from "./tenantActions";

export const createSubscriptionForTenantAutoTax =
  (priceId) => async (dispatch, getState) => {
    try {
      dispatch({ type: PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const tenantID = userInfo.tenantID;

      const { data } = await axios.post(
        `/api/tenants/${tenantID}/create-subscription-auto-tax`,
        { priceId },
        config
      );

      // console.log("createSubscriptionForTenantAutoTax data", data);

      dispatch({
        type: PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const removeAllTaxIds = () => async (dispatch, getState) => {
  try {
    dispatch({ type: PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const tenantID = userInfo.tenantID;

    const { data } = await axios.delete(
      `/api/tenants/${tenantID}/remove-all-tax-ids`,
      config
    );

    dispatch({
      type: PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const checkAndUpdateVatCode =
  (vatCode) => async (dispatch, getState) => {
    try {
      dispatch({ type: PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const tenantID = userInfo.tenantID;

      const { data } = await axios.put(
        `/api/tenants/${tenantID}/check-vat-code`,
        { vatCode },
        config
      );

      // console.log("checkAndUpdateVatCode data", data);

      dispatch({
        type: PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantAddressAndCreateSubscription =
  (
    address,
    priceId,
    companyName,
    companyCode,
    vatCode,
    isIndividual,
    fullName
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const tenantID = userInfo.tenantID;

      const { data } = await axios.put(
        `/api/payments/${tenantID}/update-address-create-subscription`,
        address,
        priceId,
        companyName,
        companyCode,
        vatCode,
        isIndividual,
        fullName,
        config
      );

      dispatch({
        type: PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getStripeBillingDetails = () => async (dispatch, getState) => {
  try {
    dispatch({ type: PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const tenantID = userInfo.tenantID;

    const { data } = await axios.get(
      `/api/tenants/${tenantID}/billing-details`,
      config
    );

    dispatch({
      type: PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getTenantStripePaymentMethodList =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const tenantID = userInfo.tenantID;

      const { data } = await axios.get(
        `/api/tenants/${tenantID}/payment-methods`,
        config
      );

      dispatch({
        type: PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createSubscriptionCheckout =
  (slug, subscriptionData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/${slug}/payments/subscriptions/create-subscription`, // ✅ FIXED URL
        { slug, ...subscriptionData }, // ✅ Ensure `tenantID` is included in the body
        config
      );

      dispatch({
        type: PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS,
        payload: data,
      });

      // Redirect to Stripe checkout page after getting the URL
      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
    } catch (error) {
      dispatch({
        type: PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const cancelTenantSubscriptionAction =
  (slug, tenantSubscription) => async (dispatch, getState) => {
    try {
      dispatch({ type: PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // const tenantID = userInfo.tenantID;

      const { data } = await axios.post(
        `/api/${slug}/payments/subscriptions/cancel`,
        { slug, tenantSubscription },
        config
      );

      dispatch({
        type: PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS,
        payload: data,
      });

      // console.log("✅ Subscription cancelation successful:", data);

      dispatch(listTenantDetailsBySlugAction(slug)); // Refresh tenant details after cancelation
    } catch (error) {
      dispatch({
        type: PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });

      console.error("❌ Subscription cancelation failed:", error);
    }
  };

export const getGlobalModulesAction = (slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: PAYMENT_TENANT_GET_MODULES_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/${slug}/payments/modules`, config);

    dispatch({
      type: PAYMENT_TENANT_GET_MODULES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAYMENT_TENANT_GET_MODULES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
